import { BrowserRouter } from 'react-router-dom';
// components
import EditorSettingsInit from '@/modules/CodeEditor/components/EditorSettingsInit';
import AppRoutes from '@/routes.tsx';
import InitApp from '@/modules/InitApp';
import IntercomWidget from '@/modules/Intercom/components/Widget';
import VibeModeDock from '@/modules/VibeMode/components/VibeModeDock';
// utils
import useAppStore from '@/store/app';

const App = () => {
    const isAuthorized = useAppStore((state) => state.isAuthorized);

    return (
        <BrowserRouter>
            <InitApp isAuthorized={isAuthorized} />
            {isAuthorized ? <EditorSettingsInit /> : undefined}
            {isAuthorized ? <IntercomWidget /> : undefined}
            <AppRoutes isAuthorized={isAuthorized} />
            <VibeModeDock />
        </BrowserRouter>
    );
};

export default App;
